import React from "react";
import Header from "../layout/Header";
import BackgroundImg from "../assets/Banner/ContactUs/ContactUsBanner.png";
import LocationsCards from "../components/ContactUs/LocationsCards";
import Form from "../components/ContactUs/Form";

const ContactUs: React.FC = () => {
  return (
    <React.Fragment>
      <div className="relative w-full h-screen flex flex-col mt-0 top-0 mb-2 contact-main-container">
        {/* Banner background image */}
        <img
          src={BackgroundImg}
          alt="About Us Banner"
          className="w-full h-[80vh] object-fill absolute top-0 left-0 z-0"
        />

        {/* Header at the very top, always above everything */}
        <div className="absolute top-0 left-0 w-full z-20">
          <Header />
        </div>

        {/* Center LocationsCards both vertically and horizontally */}
        <div className="flex flex-1 items-center justify-center relative z-0 contact-us-content-section">
          <LocationsCards />
        </div>
      </div>

      <div
        className="w-full flex justify-center my-12"
        style={{
          marginTop: "-10rem",
        }}
      >
        <div className="max-w-screen-xl w-full grid grid-cols-1 md:grid-cols-2 gap-8 px-4 md:px-0">
          {/* Google Map */}
          <div className="w-full">
            <div
              className="overflow-hidden border border-gray-200 rounded-lg shadow"
              style={{ height: 500 }}
            >
              <iframe
                title="Google Map - Across Assist"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.013073289074!2d77.0678980754062!3d28.62967668497809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d04e2e7c318e7%3A0x6e7e0e92ce40938e!2s91%2C%20Sector%2044%2C%20Gurugram%2C%20Haryana%20122003%2C%20India!5e0!3m2!1sen!2sin!4v1718030000000!5m2!1sen!2sin&maptype=satellite"
                width="100%"
                height="100%"
                style={{ border: 0, minWidth: "100%" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          {/* Contact Form */}
          <div className="w-full flex items-center">
            <Form />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactUs;
